import { TextField } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const AssignJobModalEntryForm = ({
  onAssign,
  onClose,
  taskSerial,
  assignButtonLabel,
}) => {
  const [assignMembersList, setAssignMembersList] = useState(null);
  const [assignedUsers, setAssignedUsers] = useState({});
  const [companyCode, setCompanyCode] = useState(null);
  const [instruction, setInstruction] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [assignedTaskSerials, setAssignedTaskSerials] = useState([]);

  useEffect(() => {
    fetchAssignMembersList();
  }, []);

  const fetchAssignMembersList = async () => {
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    // console.log('apiPaths_from_local_storage',apiPaths_from_local_storage)

    let apiUrlEmployeeList = `${apiPaths_from_local_storage[0].API_CONFIG}/api/PersonalInfoList/cubix/ALL/YES/ALL/ALL/ALL/ALL`;

    // https://cubixweberp.com:213/api/PersonalInfoList/cubix/ALL/YES/ALL/ALL/ALL/ALL

    try {
      // const response = await axios.get(apiUrl)
      const response = await axios.get(apiUrlEmployeeList);

      const data = response.data;
      console.log("assign members list:", data);
      setAssignMembersList(data);
      // setOpenSubmitSnackbar(true);
    } catch (err) {
      console.error("Error while fetching assign members", err);
      // setOpenSnackbar(true);
    }
  };

  const handleAssign = async (e, user, index) => {
    e.preventDefault();
    if (!scheduledDate) return;
    console.log("user:", user);

    console.log("Assigned to:", user.Name, "at", scheduledDate);
    console.log("Assigned to:", user, "at", scheduledDate);

    if (onAssign) onAssign({ ...user, scheduledDate });

    setAssignedUsers((prev) => ({
      ...prev,
      [index]: "Pending",
    }));

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-"; // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
    setCompanyCode(company_code_from_local_storage);

          const currentDepartmentFromLocalStorage = localStorage.getItem(
    "currentSelectedDepartment"
  );


   

    const assignTaskPayload = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "TASKSTATUS",
        DocNo: taskSerial,
        deptno: currentDepartmentFromLocalStorage,
        Status: "ASSIGNED",
        Comments: instruction,
        // UserID: "ADMIN",
        UserID: user.EmpId,
        created_on: scheduledDate,
      },
    ];

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/ProposalStatus`;

    try {
      const response = await axios.post(apiUrl, assignTaskPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response.data;
      console.log("Assigned task for employee", data);
      setOpenSubmitSnackbar(true);
      setAssignedTaskSerials(prev=>[...prev,taskSerial])
      assignButtonLabel("Assign",taskSerial);
    } catch (err) {
      console.error("Error while assigning task", err);
      setOpenSnackbar(true);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredAssignMembers, setFilteredAssignMembers] =
    useState(assignMembersList);

  useEffect(() => {
    const searchedAssignMembers = assignMembersList?.filter((item) =>
      item?.Name.toLowerCase().includes(searchTerm.toLocaleLowerCase())
    );
    setFilteredAssignMembers(searchedAssignMembers);
  }, [searchTerm, assignMembersList]);

  const getCurrentDateTimeShort = () => {
    const now = new Date();
    // Adjust for local timezone
    const localDateTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    );
    return localDateTime.toISOString().slice(0, 19);
  };
  const [scheduledDate, setScheduledDate] = useState(getCurrentDateTimeShort());

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    // setDuplicateItemCodeSnackbar(false);
  };
  return (
    <div className="p-4 bg-white rounded-2xl shadow-xl ">
      {/* Header */}
      <div>
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center sticky top-0 bg-white z-20 py-2 px-2 ">
          <h2 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-0">
            Assign Job To
          </h2>
          <button
            className="text-3xl text-gray-600 hover:text-red-500 transition-colors"
            onClick={onClose}
            title="Close"
          >
            &times;
          </button>
        </div>

        <div className="flex items-center justify-left gap-4 w-full sm:w-auto ">
          <TextField
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search Assign Person..."
            variant="standard"
            size="small"
            fullWidth
            // className="pt-2"
            sx={{
              maxWidth: { xs: "100%", sm: 300 },
              height: 12,
              // backgroundColor: 'white',
              // boxShadow: 1,
              borderRadius: 1,
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            id="datetime-local"
            label="Shedule Date & Time"
            type="datetime-local"
            variant="standard"
            value={scheduledDate}
            onChange={(e) => setScheduledDate(e.target.value)}
            // defaultValue="2017-05-24T10:30"
            className="mb-4"
            InputLabelProps={{
              shrink: true,
              step: 1,
            }}
          />

          {/* </div> */}
        </div>

        <div className="mt-4">
          <TextField
            label="Instruction"
            name="instruction"
            variant="standard"
            fullWidth
            multiline
            required
            error={instruction === ""}
            helperText={instruction === "" ? "Enter Task Instruction" : ""}
            rows={1}
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
            InputLabelProps={{ shrink: true }}
            className="mb-4"
            sx={{
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important",
              },
            }}
          />
        </div>
      </div>

      {/* User List */}
      <div className="mt-4 space-y-3 max-h-[50vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
        {filteredAssignMembers?.length > 0 ? (
          filteredAssignMembers.map((user, index) => (
            <div
              // key={user.id}
              key={index}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-gray-100 p-3 rounded shadow-sm"
            >
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm font-medium text-gray-800">
                <span>{user.EmpId}</span>
                <span>{user.Name}</span>
                <span>{user.JobTitle}</span>
                <span>{user.Division}</span>
              </div>

              <button
                onClick={(e) => handleAssign(e, user, index)}
                disabled={!scheduledDate || !instruction}
                className={`mt-2 sm:mt-0 px-3 py-1.5 rounded transition-colors text-sm ${
                  !scheduledDate || !instruction
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                {assignedUsers[index] || "Assign"}
              </button>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500 text-center py-4">
            No matching members found.
          </p>
        )}
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          Error while assigning task!
        </MuiAlert>
      </Snackbar>
    
      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          Task Assigned Successfully!
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default AssignJobModalEntryForm;
